
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/inloggen",
      function () {
        return require("private-next-pages/auth/inloggen.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/inloggen"])
      });
    }
  